(() => {
  const toggle = (event) => {
    event.preventDefault();
    document.querySelector('body').classList.toggle('js-body-nav-toggle');
  };
  const initialize = (navToggle) => {
    const element = navToggle.element;

    element.addEventListener('click', toggle);
  };

  const navToggle = stp.setup('nav-toggle');

  navToggle.map(initialize);
})();
